
<nav>
  <ul class="pagination-wrap">
    <li class="page-item icon-group" [class.disabled]="activePage === 1" (click)="onSelect(1)">
      <i class="icon icon-chevron-left"></i>
      <i class="icon icon-chevron-left"></i>
    </li>
    <li class="page-item" [class.disabled]="activePage === 1" (click)="onPrev()">
      <i class="icon icon-chevron-left"></i>
    </li>
    <li class="page-item numbers" (click)="onSelect(page)" [class.selected]="activePage === page" *ngFor="let page of pages">
      <a>{{page}}</a>
    </li>
    <li class="page-item" [class.disabled]="activePage === totalPages" (click)="onNext()">
      <i class="icon icon-chevron-right"></i>
    </li>
    <li class="page-item icon-group" [class.disabled]="activePage === totalPages" (click)="onSelect(totalPages)">
      <i class="icon icon-chevron-right"></i>
      <i class="icon icon-chevron-right"></i>
    </li>
  </ul>
</nav>
